import React from "react"
// https://documentation.formspark.io/setup/spam-protection.html#honeypot
const FormInputHoneypot = () => {
  return (
    <div className="c-form__honeypot">
      <input type="text" tabIndex={-1} autoComplete="off" name="_honeypot" />
    </div>
  )
}

export default FormInputHoneypot
